"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributeDisplayFormSelect = void 0;
var tslib_1 = require("tslib");
// (C) 2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var AttributeDisplayFormDropdown_1 = require("./AttributeDisplayFormDropdown");
var AttributeFilterContext_1 = require("../../../Context/AttributeFilterContext");
/**
 * Component that render Attribute display forms selector as dropdown.
 * @internal
 */
exports.AttributeDisplayFormSelect = function (props) {
    var onSelect = props.onSelect, alignPoints = props.alignPoints;
    var _a = AttributeFilterContext_1.useAttributeFilterContext(), displayForms = _a.displayForms, currentDisplayFormRef = _a.currentDisplayFormRef;
    return (react_1.default.createElement(AttributeDisplayFormDropdown_1.AttributeDisplayFormDropdown, { displayForms: displayForms, selectedDisplayForm: currentDisplayFormRef, alignPoints: alignPoints, onSelect: onSelect }));
};
//# sourceMappingURL=AttributeDisplayFormSelect.js.map